/**
 * Sample Data Seeder
 * Use this to populate the app with demo data for testing
 */

import { generateSKU } from './skuGenerator';

export const sampleItems = [
  {
    name: 'Classic Cotton T-Shirt',
    brand: 'Essentials Co.',
    defaultPrice: 29.99,
    colors: [
      {
        name: 'Navy Blue',
        sizes: [
          { name: 'S', quantity: 15, price: 29.99 },
          { name: 'M', quantity: 20, price: 29.99 },
          { name: 'L', quantity: 18, price: 29.99 },
          { name: 'XL', quantity: 12, price: 29.99 }
        ]
      },
      {
        name: 'White',
        sizes: [
          { name: 'S', quantity: 10, price: 29.99 },
          { name: 'M', quantity: 25, price: 29.99 },
          { name: 'L', quantity: 20, price: 29.99 },
          { name: 'XL', quantity: 8, price: 29.99 }
        ]
      },
      {
        name: 'Black',
        sizes: [
          { name: 'S', quantity: 12, price: 29.99 },
          { name: 'M', quantity: 30, price: 29.99 },
          { name: 'L', quantity: 25, price: 29.99 },
          { name: 'XL', quantity: 15, price: 29.99 }
        ]
      }
    ]
  },
  {
    name: 'Slim Fit Jeans',
    brand: 'Urban Threads',
    defaultPrice: 79.99,
    colors: [
      {
        name: 'Dark Denim',
        sizes: [
          { name: '28', quantity: 8, price: 79.99 },
          { name: '30', quantity: 12, price: 79.99 },
          { name: '32', quantity: 15, price: 79.99 },
          { name: '34', quantity: 10, price: 79.99 },
          { name: '36', quantity: 6, price: 79.99 }
        ]
      },
      {
        name: 'Light Wash',
        sizes: [
          { name: '28', quantity: 5, price: 79.99 },
          { name: '30', quantity: 10, price: 79.99 },
          { name: '32', quantity: 12, price: 79.99 },
          { name: '34', quantity: 8, price: 79.99 }
        ]
      }
    ]
  },
  {
    name: 'Hooded Sweatshirt',
    brand: 'Essentials Co.',
    defaultPrice: 59.99,
    colors: [
      {
        name: 'Grey Heather',
        sizes: [
          { name: 'S', quantity: 10, price: 59.99 },
          { name: 'M', quantity: 15, price: 59.99 },
          { name: 'L', quantity: 18, price: 59.99 },
          { name: 'XL', quantity: 12, price: 59.99 },
          { name: 'XXL', quantity: 8, price: 64.99 }
        ]
      },
      {
        name: 'Navy',
        sizes: [
          { name: 'S', quantity: 8, price: 59.99 },
          { name: 'M', quantity: 12, price: 59.99 },
          { name: 'L', quantity: 15, price: 59.99 },
          { name: 'XL', quantity: 10, price: 59.99 }
        ]
      }
    ]
  },
  {
    name: 'Summer Dress',
    brand: 'Bloom Fashion',
    defaultPrice: 89.99,
    colors: [
      {
        name: 'Floral Print',
        sizes: [
          { name: 'XS', quantity: 6, price: 89.99 },
          { name: 'S', quantity: 10, price: 89.99 },
          { name: 'M', quantity: 12, price: 89.99 },
          { name: 'L', quantity: 8, price: 89.99 }
        ]
      },
      {
        name: 'Solid Blue',
        sizes: [
          { name: 'XS', quantity: 4, price: 89.99 },
          { name: 'S', quantity: 8, price: 89.99 },
          { name: 'M', quantity: 10, price: 89.99 },
          { name: 'L', quantity: 6, price: 89.99 }
        ]
      }
    ]
  },
  {
    name: 'Athletic Shorts',
    brand: 'Urban Threads',
    defaultPrice: 39.99,
    colors: [
      {
        name: 'Black',
        sizes: [
          { name: 'S', quantity: 12, price: 39.99 },
          { name: 'M', quantity: 18, price: 39.99 },
          { name: 'L', quantity: 15, price: 39.99 },
          { name: 'XL', quantity: 10, price: 39.99 }
        ]
      },
      {
        name: 'Red',
        sizes: [
          { name: 'S', quantity: 8, price: 39.99 },
          { name: 'M', quantity: 12, price: 39.99 },
          { name: 'L', quantity: 10, price: 39.99 }
        ]
      }
    ]
  }
];

/**
 * Transform sample data to app format
 */
export const transformSampleData = () => {
  return sampleItems.map(item => {
    const sku = generateSKU(); // Generate 6-digit numeric SKU
    const variations = [];

    item.colors.forEach(color => {
      color.sizes.forEach(size => {
        variations.push({
          color: color.name,
          size: size.name,
          quantity: size.quantity,
          price: size.price,
          sku: `${sku}-${color.name.substring(0, 3).toUpperCase()}-${size.name.toUpperCase()}`
        });
      });
    });

    return {
      id: `sample_${sku}`,
      name: item.name,
      brand: item.brand || '',
      defaultPrice: item.defaultPrice,
      sku: sku,
      variations: variations,
      createdAt: new Date().toISOString()
    };
  });
};

/**
 * Load sample data into localStorage
 */
export const loadSampleData = () => {
  const sampleData = transformSampleData();
  localStorage.setItem('square_items', JSON.stringify(sampleData));
  // Populate brands from sample data
  const brands = [...new Set(sampleItems.map(i => i.brand).filter(Boolean))].sort();
  localStorage.setItem('square_brands', JSON.stringify(brands));
  return sampleData;
};

/**
 * Clear all data from localStorage
 */
export const clearAllData = () => {
  localStorage.removeItem('square_items');
  localStorage.removeItem('square_brands');
  localStorage.removeItem('square_categories');
  return [];
};
